import qs from 'qs';
import client from './client';

const baseUrl = '/api/v1/project/orders/bill-collect';

// 수금/지급 내역 조회. 목록 화면과 엑셀 다운로드가 이 결과를 함께 쓴다.
export const getCollectList = (searchData) =>
  client.get(`${baseUrl}/list?${qs.stringify(searchData, { skipNulls: true })}`);

// 수금 현황 + 내역. 취소분도 함께 온다 — 금액 이력이라 화면에서 취소 표시로 보여준다.
export const getCollectSummary = (invUuid) => client.get(`${baseUrl}/${invUuid}`);

export const addCollect = (invUuid, payload) => client.post(`${baseUrl}/${invUuid}`, payload);

export const updateCollect = (collectUuid, payload) =>
  client.put(`${baseUrl}/detail/${collectUuid}`, payload);

// 삭제가 아니라 취소다. 사유는 서버에서 필수다.
export const cancelCollect = (collectUuid, reason) =>
  client.delete(`${baseUrl}/detail/${collectUuid}`, { data: { reason } });
